import {
    RESET_SUPPORT_ACTION_STATE,
    RESET_SUPPORT_STATE,
    GET_SUPPORT_CREATE,
    GET_SUPPORT_CREATE_SUCCESS,
    GET_SUPPORT_CREATE_FAIL,
} from "./actionTypes";

export const getSupportCreate = (data) => ({
    type: GET_SUPPORT_CREATE,
    payload: data,
});

export const getSupportCreateSuccess = data => ({
    type: GET_SUPPORT_CREATE_SUCCESS,
    payload: data,
});

export const getSupportCreateFail = error => {
    return {
        type: GET_SUPPORT_CREATE_FAIL,
        payload: error,
    };
};

//reset
export const resetSupportActionState = () => {
    return {
        type: RESET_SUPPORT_ACTION_STATE,
    }
}
export const resetSupportState = () => {
    return {
        type: RESET_SUPPORT_STATE,
    }
}

